import Paper from '@mui/material/Paper';
import { useTranslation } from 'react-i18next';

import { SectionHeader } from '../section-header';
import type {
  AdvancePaymentDetails,
  AgreementAndApprovalsDetails,
} from '../agreement-and-approvals.schema';
import { LoanSummaryDetails } from './loan-summary-details';
import { AdvancedAmount } from './advanced-amount';

interface AgreementAndApprovalsSummaryProps {
  advancePayment: AdvancePaymentDetails;
  details: AgreementAndApprovalsDetails;
  isSelectedLibierisLoan: boolean;
}

export function AgreementAndApprovalsSummary({
  advancePayment: { min, max },
  details,
  isSelectedLibierisLoan,
}: AgreementAndApprovalsSummaryProps) {
  const { t } = useTranslation();

  return (
    <Paper sx={{ padding: '16px 24px' }}>
      <SectionHeader sx={{ marginBottom: 2 }}>
        {t('loanProcess.loanSteps.agreementAndApprovals.summary.title')}
      </SectionHeader>
      <AdvancedAmount
        advancePayment={{
          max,
          min,
        }}
        currency={details.currency}
        withEditMode={!isSelectedLibierisLoan}
      />
      <LoanSummaryDetails details={details} />
    </Paper>
  );
}
